import tailwindColors from "tailwindcss/colors";
// const { colors } = require("./frontend/tailwindV1Colors");
import defaultTheme from "tailwindcss/defaultTheme";

import { colors } from "./frontend/tailwindV1Colors";
// const tailwindColors = require("tailwindcss/colors");
import baseConfig from "./tailwind.bustle.config";

/** @type {import('tailwindcss').Config} */

// We did funny ( wrong ) things with the font sizes on the management site
// That we will need to fix at some point

// But for the onsite app we want to use the default font sizes
export default {
  ...baseConfig,
  theme: { ...baseConfig.theme, fontSize: defaultTheme.fontSize },
};
